import 'select2/dist/js/select2.full.js'

jQuery(document).bind('gform_post_render', function (event, form_id) {

    if ( form_id === 3 || form_id === 4 || form_id=== 6 || form_id === 20 ) {

        jQuery('.ginput_container_select select').select2({
            width: '100%'
        })
        jQuery('.ginput_complex select').select2({
            width: '100%'
        })

    }

})
